import { render, staticRenderFns } from "./ContactUsForm.vue?vue&type=template&id=580f3aba&scoped=true&"
import script from "./ContactUsForm.vue?vue&type=script&lang=js&"
export * from "./ContactUsForm.vue?vue&type=script&lang=js&"
import style0 from "./ContactUsForm.vue?vue&type=style&index=0&id=580f3aba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580f3aba",
  null
  
)

export default component.exports